// Mock data for Arogya Vitalis Landing Page

export const mockData = {
  contact: {
    whatsapp: "+919766144233",
    linkedin: "https://www.linkedin.com/in/tanmayee-nookala/",
    email: "contact@arogyavitalis.com" // Placeholder
  },
  
  hero: {
    headline: "Your body isn't built to resist temptation all day",
    subheadline: "Ice cream appears. Cravings follow. Willpower fades. Lasting health isn't about saying 'no' more often. It's about designing an ecosystem where fewer no's are required.",
    cta: "Book Your 1:1 Consultation"
  },

  painPoints: [
    "I eat so little, but I still gain weight.",
    "By afternoon, my energy crashes.",
    "I have PCOS and I don't know what to eat.",
    "Everything I like is unhealthy.",
    "I feel hungry soon after eating.",
    "I can't stick to a diet with my schedule."
  ],

  services: [
    {
      title: "Sustainable Weight Management",
      description: "Without extreme restriction or rigid diets"
    },
    {
      title: "Gut & Digestive Health",
      description: "Address bloating, acidity, irregular digestion, and low appetite"
    },
    {
      title: "PCOS & Hormonal Balance",
      description: "Support through nutrition and lifestyle alignment"
    },
    {
      title: "Energy & Vitality",
      description: "Reduce fatigue, lethargy, and brain fog"
    },
    {
      title: "Metabolic Health",
      description: "Improve blood markers: sugar levels, cholesterol, nutritional deficiencies"
    },
    {
      title: "Skin Health",
      description: "Linked to lifestyle patterns and hormonal changes"
    },
    {
      title: "Healthy Food Relationship",
      description: "Break free from repeated dieting cycles"
    },
    {
      title: "Long-term Lifestyle Correction",
      description: "Habits that hold up in real life, not short-term fixes"
    }
  ],

  process: [
    {
      step: 1,
      title: "Initial Alignment Conversation",
      description: "A brief call to understand your goals, lifestyle, and concerns and which programme is right for you."
    },
    {
      step: 2,
      title: "Programme Information Pack",
      description: "You receive a structured document that outlines the programme framework, inclusions, support approach, and expectations around engagement."
    },
    {
      step: 3,
      title: "Comprehensive Client Assessment",
      description: "Once you confirm, a comprehensive information form is shared to capture dietary habits, lifestyle patterns, medical history, symptoms, and personal constraints, ensuring a complete and accurate baseline understanding."
    },
    {
      step: 4,
      title: "Diagnostic Review",
      description: "You are advised on relevant blood tests to assess internal markers that influence health and nutrition outcomes."
    },
    {
      step: 5,
      title: "Deep-Dive Consultation & Body Composition Analysis",
      description: "Blood reports and body composition are reviewed, lifestyle patterns are discussed in depth, and initial recommendations are shared, giving you an understanding of the current health and practical actions to begin with."
    },
    {
      step: 6,
      title: "Onboarding & Guideline Kit",
      description: "You receive a preparation guide covering essential groceries, supplements (if needed), and practical readiness before starting."
    },
    {
      step: 7,
      title: "Personalised Nutrition Plan & Walkthrough call",
      description: "A fully customised nutrition plan aligned to your health data, lifestyle, and goals is shared. A dedicated call to walk through the plan, clarify doubts, and align on execution."
    },
    {
      step: 8,
      title: "Daily Guidance & Real-Time Feedback",
      description: "You share meal updates and receive feedback on portions, food combinations, and practical adjustments, enabling real-time guidance, better adherence, and timely course correction."
    },
    {
      step: 9,
      title: "Progress-led Plan Refinement",
      description: "Regular weekly or fortnightly check-ins assess challenges and progress, with necessary adjustments and additional support such as travel or eating-out guidance."
    },
    {
      step: 10,
      title: "Goal Achievement & Long-Term Confidence",
      description: "By the end of the programme, clients gain a deeper understanding of their body, make confident food choices, and follow sustainable systems, leaving them empowered."
    }
  ],

  about: {
    name: "Tanmayee Nookala",
    title: "Founder & Chief Nutritionist",
    credentials: "M.Sc. (Nutritional Sciences) | B.Sc. (Home Science - Nutrition)",
    experience: "200+ clients guided",
    description: "Tanmayee Nookala is a Clinical and Lifestyle Nutritionist with a Masters in Nutritional Sciences from Symbiosis University, Pune and a Bachelors in Home Science (with Nutrition specialisation). She has supported 200+ clients through structured, evidence-based programs and now leads the nutrition philosophy at Arogya Vitalis, focused on clarity, consistency, and sustainable health. Having lived across North and South India, Tanmayee brings strong cultural understanding to her nutrition practice, with familiarity across regional cuisines and food habits. Fluent in English, Hindi, Marathi and Telugu, she designs plans that feel familiar, practical, and easy to sustain in everyday Indian households.",
    imageUrl: "https://customer-assets.emergentagent.com/job_c7ce965f-b752-41cd-938a-aad5b5cd43c6/artifacts/1scuwz83_WhatsApp%20Image%202026-02-21%20at%201.01.35%20PM.jpeg"
  },

  programs: [
    {
      id: 1,
      name: "Starter Consultation",
      price: "₹1,500",
      duration: "One-time",
      subtitle: "One-time clarity before you commit",
      description: "Best for you if you want professional direction without long-term commitment.",
      includes: [
        "60-minute 1:1 Zoom consultation",
        "Deep understanding of your lifestyle, work routine, food habits, and goals",
        "Basic review of recent blood reports",
        "Clear expectation setting around timelines, outcomes, and effort required",
        "Broad, practical dietary guidelines you can start implementing immediately"
      ],
      outcome: "You leave with clarity, not confusion, and a realistic direction forward.",
      featured: false
    },
    {
      id: 2,
      name: "3-Month Transformation Plan",
      price: "₹14,800",
      duration: "3 Months",
      badge: "MOST CHOSEN",
      description: "The best balance of results, support, and value for working professionals committed to lasting change.",
      includes: [
        "60-minute in-depth Zoom/in-person consultation at the start",
        "Monthly Zoom/in-person review to reassess progress and refine strategy",
        "4 fully customised nutrition plans tailored to different phases and situations",
        "Weekly phone check-ins for tight accountability",
        "Blood marker assessments",
        "Priority WhatsApp access for quicker feedback",
        "Hands-on support during: Social events, Stressful work phases, Travel and disrupted routines",
        "Meal picture reviews with feedback on portion size, balance and goal alignment",
        "One comprehensive blood report review during the program, with nutrition based insights"
      ],
      featured: true
    },
    {
      id: 3,
      name: "6-Month Transformation Pro Plan",
      price: "₹27,000",
      duration: "6 Months",
      description: "Maximum support & faster course correction. Best for you if you want closer guidance, quicker adjustments, and higher accountability.",
      includes: [
        "60-minute in-depth Zoom/in-person consultation at the start",
        "Monthly Zoom/in-person review to reassess progress and refine strategy",
        "7 fully customised nutrition plans tailored to different phases and situations",
        "Weekly phone check-ins for tight accountability",
        "Blood marker assessments",
        "Priority WhatsApp access for quicker feedback",
        "Hands-on support during: Social events, Stressful work phases, Travel and disrupted routines",
        "Meal picture reviews with feedback on portion size, balance and goal alignment",
        "One comprehensive blood report review during the program, with nutrition based insights"
      ],
      outcome: "Less guesswork, faster corrections, and confidence that you're doing the right things.",
      featured: false
    }
  ],

  faqs: [
    {
      question: "Do I need to already have 'good' eating habits to start?",
      answer: "Not at all. People start this programme at very different points. Some feel confused about food choices. Others eat fairly well but feel inconsistent. Both are equally valid starting points. We start with your reality, not what Instagram says you should be doing. You don't need perfect habits to begin. My role is to meet you where you are and help you build habits gradually, without overwhelm or judgement."
    },
    {
      question: "Can this work if I eat regular home food with my family?",
      answer: "Absolutely. This approach is built around regular food like Rotis, rice, sabzi, dal, curries etc. Many home foods are already nutritious. The work is about adjusting frequency, portions, ingredients and combinations. We increase what supports your health and reduce what doesn't. You won't be asked to eat unfamiliar dishes or follow 'diet food.'"
    },
    {
      question: "What kinds of food changes does this usually involve?",
      answer: "There will be changes. Some foods that are oily, heavily processed will be reduced because they don't support your goals. This is necessary. At the same time, we don't jump to extremes right at the beginning. The focus is on improving everyday meals by adjusting portions, frequency, timing, and balance gradually. You'll get a meal plan in advance so you can plan groceries and meals ahead of time. This structure is intentional. It removes guesswork and makes consistency easier without relying only on willpower."
    },
    {
      question: "Can this work with irregular work hours, eating out, travel, or social events?",
      answer: "Yes, but it requires conscious choices and some planning. Irregular schedules do make consistency harder. We don't expect avoidance of social life. You'll learn how to prioritise on busy days, make better choices with limited options, and get back on track without guilt. Progress comes from awareness and adaptability, so decisions start coming from what your body needs. That's what makes this sustainable in real life."
    },
    {
      question: "How is this different from a generic diet plan or meal chart?",
      answer: "Generic plans hand you a one-size-fits-all chart and expect compliance. Our approach is personalised to your body, lifestyle, habits, and health markers in depth while designing your plan. What truly sets this apart is ongoing guidance. You don't just receive a plan and figure it out alone. You get real-time feedback, regular reviews, and adjustments throughout the programme."
    },
    {
      question: "How do you measure progress beyond just body weight?",
      answer: "Think of your health journey like a puzzle. Weight is just one piece. We also track energy levels, sleep quality, digestion, cravings, mood, strength, measurements, symptoms, and blood parameters where relevant. Many clients notice these improvements well before the scale changes. And often, those changes are the signs that real, lasting progress is happening."
    },
    {
      question: "What if results are slower than expected?",
      answer: "That's completely normal. Every body responds differently, and progress can be influenced by stress, sleep, hormones, routine, and consistency. If things feel slow, we reassess and adjust instead of tightening rules or adding pressure. Slow, steady progress usually lasts far longer than quick fixes and that's what we're aiming for."
    },
    {
      question: "Is this a guaranteed-results programme?",
      answer: "There's no honest way to guarantee a specific outcome because every body is different. What we can promise is that we use personalised, evidence-based methods and put in genuine effort to support you. With consistent effort from your side and strong accountability from us, results do come even if they take time."
    },
    {
      question: "What am I actually paying for beyond a meal plan?",
      answer: "You're paying for strategy, guidance, and accountability, not just a list of foods. Meal plans are tools. The real value lies in understanding your challenges, adjusting the approach when life happens, and helping you stay consistent without guilt or burnout. You're also paying for experienced oversight. Someone who reviews patterns, flags issues early, asks the right questions, and course-corrects before small lapses turn into long breaks. That steady involvement is what keeps progress moving."
    },
    {
      question: "What happens after the programme ends?",
      answer: "The aim is to make you independent. By the end of the programme, you should feel confident making food choices, adjusting portions, handling travel or social events, and getting back on track when things go off-plan. It's about building skills, awareness, and trust in your own decisions so you can support your health long-term."
    }
  ],

  testimonials: [
    {
      name: "Saksha Bhagwan",
      profession: "Lawyer",
      location: "Bangalore",
      quote: "I absolutely loved working with Tanmayee. She curated a plan that was realistic, easy to follow, and perfectly suited to my lifestyle. Throughout the process, she were super helpful and made sure to follow up frequently, which really kept me motivated and accountable. What stood out the most was how informative and insightful they were. I learned so much about my eating habits and how to make sustainable changes. Tanmayee was incredibly sweet, supportive, and genuinely care about the progress which made it easier to keep up with. I'd highly recommend her to anyone looking for a professional yet personal approach to better nutrition."
    },
    {
      name: "Zara Khan",
      profession: "Service Industry",
      location: "USA",
      quote: "I've been working with Tanmayee and she has been amazing! She guided me in making small, manageable changes that have had a real impact on my weight loss journey—things I couldn't have figured out on my own. She also kept me accountable and was always approachable whenever I had questions or needed support."
    },
    {
      name: "Uma",
      profession: "IT",
      location: "Chennai",
      quote: "My son is a swimmer and consulting with Tanmayee for almost 6 months. She is very responsive and most caring person. My son's performance improved a lot. And also, he is happy with diet plan given by Tanmayee as she is considering my son's choice of food and giving alternatives for his dislikes. Periodic follow ups and guidance for competition are on time response which makes me hassle free experience."
    },
    {
      name: "Lakshmi",
      profession: "Homemaker",
      location: "Bangalore",
      quote: "I am very thankful Tanmayee ma'am. Before going there my son was having regular stomach problems and gut issues but now he is recovered from those problems and grown tall also. On regular basis now he is taking his food properly.. especially pasta with soya panneer sauce recipe is amazing :)"
    }
  ],

  whyThreeMonths: {
    title: "Why 3 Months?",
    description: "Real transformation takes time. Here's why 3 months is the sweet spot:",
    reasons: [
      {
        title: "Month 1: Foundation",
        description: "Understanding your body, establishing initial habits, and starting to see early wins in energy and digestion."
      },
      {
        title: "Month 2: Momentum",
        description: "Visible physical changes, deeper habit integration, and navigating real-life challenges with support."
      },
      {
        title: "Month 3: Confidence",
        description: "Sustainable patterns are set, you're making independent choices, and the transformation feels natural."
      }
    ]
  }
};
